import {TiVendorMicrosoft, TiWeatherPartlySunny, TiWeatherSunny } from "react-icons/ti";
import {BsBucket, BsCalendarDate } from 'react-icons/bs';
import {MdImageSearch, MdOutlineEventNote, MdTranslate } from 'react-icons/md';
import { AiOutlineApi } from 'react-icons/ai';
import {TbBrandGoogle, TbDatabaseLeak, TbDatabaseSearch, TbUserQuestion, TbWorldSearch } from 'react-icons/tb';
import {GoArchive, GoDiscussionOutdated, GoLaw } from 'react-icons/go';
import {FaCode} from "react-icons/fa6";
import { LuBookMarked, LuImagePlus } from 'react-icons/lu';
import {PiMathOperationsBold, PiSpeakerHighBold } from 'react-icons/pi';
import {IoLibraryOutline, IoSpeedometerOutline } from 'react-icons/io5';
import {TfiPin} from "react-icons/tfi";
import { GiPathDistance } from 'react-icons/gi';
import {RiGovernmentLine, RiPresentationLine } from 'react-icons/ri';
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import {SiArxiv, SiThemoviedatabase} from "react-icons/si";

export enum AgentSkillType {
    LLM_BASE_KNOWLEDGE = 'LLM_BASE_KNOWLEDGE',
    CONVERSATION_HISTORY = 'CONVERSATION_HISTORY',
    DATE_AND_TIME = 'DATE_AND_TIME',  // with or without location
    FILE_BUCKET = 'FILE_BUCKET',
    RT_RAG = 'RT_RAG',
    WEB_SEARCH = 'WEB_SEARCH',  // Full or on certain pages, with or without restriction on certraon css selectors
    WEATHER_CURRENT = 'WEATHER_CURRENT',
    WEATHER_FORECAST = 'WEATHER_FORECAST',
    ROUTING = 'ROUTING',
    POINT_OF_INTERESTS = 'POINT_OF_INTERESTS',
    CALCULATOR = 'CALCULATOR',
    TRANSLATOR = 'TRANSLATOR',
    IMAGE_UNDERSTANDING = 'IMAGE_UNDERSTANDING',
    IMAGE_CREATION = 'IMAGE_CREATION',
    TEXT_TO_SPEECH = 'TEXT_TO_SPEECH',
    INTERVIEWS = 'INTERVIEWS',
    DE_VH_KURSE = 'VH_KURSE_DE',
    DE_SERVICE_BW = 'SERVICE_BW',
    DE_DIGITALE_BIB = 'DE_DIGITALE_BIB',
    OPEN_LIBRARY = 'OPEN_LIBRARY',
    GOOGLE_BOOKS = 'GOOGLE_BOOKS',
    ARXIV = 'ARXIV',
    DEJURE = 'DEJURE_ORG',
    DE_TEXTARCHIV = 'DE_TEXTARCHIV',
    TMDB = 'TMDB',
    ENAIO = 'ENAIO',
    PIROBASE = 'PIROBASE',
    SHAREPOINT = 'SHAREPOINT',
    STAFFBASE = 'STAFFBASE',    
    OPARL = 'OPARL',
    CUSTOM_API = 'CUSTOM_API',
    KOMMONE_EVENT = 'KOMMONE_EVENT',
}

export interface AgentSkillTypeInfo {
    type: AgentSkillType;
    name: string;
    description: string;
    icon: React.ComponentType;
    configurationFields: Array<AgentSkillSetting>;
}

// the actual instances of an AgentSkillTye, configured by the user
export interface AgentSkill {
    id: string,
    type: AgentSkillType;
    // name: string;
    description: string;  // when to use this skill
    status: 'active' | 'inactive' | 'error';
    configuration: Record<string, any>;
    lastUpdated?: Date;
}

export interface AgentSkillSetting {
    key: string;
    label: string;
    type: 'text' | 'url' | 'select' | 'number' | 'textarea';
    required: boolean;
    options?: string[];
    defaultValue?: string;
    read_only?: boolean;
}

export let AGENT_SKILL_TYPES: Record<AgentSkillType, AgentSkillTypeInfo>;
AGENT_SKILL_TYPES = {

    [AgentSkillType.LLM_BASE_KNOWLEDGE]: {
        type: AgentSkillType.LLM_BASE_KNOWLEDGE,
        name: 'LLM Basiswissen',
        description: 'Der Agent kann das Basiswissen des LLMs nutzen.',
        icon: LuBookMarked,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'direct-answer-tool',
                read_only: true,
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 'Use this tool for a question (input) that is answerable directly.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Zusätzliche Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: ''
            },
        ]
    },

    [AgentSkillType.CONVERSATION_HISTORY]: {
        type: AgentSkillType.CONVERSATION_HISTORY,
        name: 'Chatverlauf',
        description: 'Der Agent kennt den Chatverlauf der Session.',
        icon: GoDiscussionOutdated,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'chatverlauf',
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 'Use this to access the past conversation between the user and the AI in this session.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: ''
            },
        ]
    },

    [AgentSkillType.DATE_AND_TIME]: {
        type: AgentSkillType.DATE_AND_TIME,
        name: 'Datum und Uhrzeit',
        description: 'Der Agent kennt das aktuelle Datum und die aktuelle Uhrzeit.',
        icon: BsCalendarDate,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'current-datetime'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Use this tool to fetch the current date and time in a timezone given by the TZ ' +
                    'identifier in table 2025b of the tz database. Default is {timezone}. ' +
                    'Response is in iso format.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: ''
            },
            {
                key: 'deafultTimeZoneName',
                label: 'Optional: Zeitzone',
                type: 'text',
                required: false,
                defaultValue: 'Europe/Berlin'
            },
        ]
    },

    [AgentSkillType.FILE_BUCKET]: {
        type: AgentSkillType.FILE_BUCKET,
        name: 'Dokumenten-Eimer',
        description: 'Der Agent kennt den Inhalt aller Dateien in diesem Eimer.',
        icon: BsBucket,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: true
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 'tbd',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: ''
            },
        ]
    },

    [AgentSkillType.RT_RAG]: {
        type: AgentSkillType.RT_RAG,
        name: 'Echtzeit-RAG',
        description: 'Der Agent kann das realtime-RAG pattern nutzen.',
        icon: IoSpeedometerOutline,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'rt-RAG'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Use this tool to fetch up-to-date information from websites, especially ' +
                    'for event dates, locations, or details that might change over time. \n' +
                    'The sources are about {web_rag_city}. \n' +
                    'The sources are in {sources_lang} language. \n' +
                    'The tool can query the following sources: {web_rag_base_url}.\n' +
                    'The tool can translate the input query to the sources language if necessary.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'web_rag_city',
                label: 'Always relate your Answer to...',
                type: 'text',
                required: true,
            },
            {
                key: 'sources_lang',
                label: 'Sprache der Datenquelle',
                type: 'text',
                required: true,
                defaultValue: 'German',
            },
            {
                key: 'web_rag_base_url',
                label: 'Base URL:',
                type: 'text',
                required: true
            },
            {
                key: 'webRagSelectorsStr',
                label: 'Optional: Element Selector(s)',
                type: 'text',
                required: false
            },
            {
                key: 'web_rag_max_search_results',
                label: 'Factor',
                type: 'number',
                required: true,
                defaultValue: '2',
            },
        ]
    },

    [AgentSkillType.WEB_SEARCH]: {
        type: AgentSkillType.WEB_SEARCH,
        name: 'Web-Suche',
        description: 'Der Agent kann das Internet durchsuchen und die Ergebnisse nutzen.',
        icon: TbWorldSearch,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'Web-search'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Use this tool to fetch up-to-date information from websites in the internet. ' +
                    'The sources are in {sources_lang} language. ' +
                    'The tool can translate the input query to the sources language if necessary. ',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'max_search_results',
                label: 'Anzahl Treffer (max)',
                type: 'number',
                required: true
            },
            {
                key: 'urls',
                label: 'Optional: URLs (Komma-getrennt)',
                type: 'text',
                required: false
            },
            {
                key: 'page_description',
                label: 'Optional: Beschreibung der Seite(n)',
                type: 'text',
                required: false
            },
            {
                key: 'selectors',
                label: 'Optional: Selektoren (Komma-getrennt)',
                type: 'text',
                required: false
            },
        ]
    },

    [AgentSkillType.WEATHER_CURRENT]: {
        type: AgentSkillType.WEATHER_CURRENT,
        name: 'Wetter (aktuell)',
        description: 'Der Agent kennt das aktuelle Wetter.',
        icon: TiWeatherPartlySunny,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'weather-current'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Fetches real-time weather data from the OpenWeatherMap API for a given named location (like a city). \n' +
                    'Use this tool when asked about current weather, humidity, wind-speed, or temperature information.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'location',
                label: 'Optional: Ort',
                type: 'text',
                required: false
            },
        ]
    },

    [AgentSkillType.WEATHER_FORECAST]: {
        type: AgentSkillType.WEATHER_FORECAST,
        name: 'Wetter (Vorhersage)',
        description: 'Der Agent kennt die Wettervorhersage und kann sie nutzen.',
        icon: TiWeatherSunny,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'weather-forecast'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Fetches detailed and summarized 5-day weather forecast data from the OpenWeatherMap API ' +
                    'for a given location. Daily averages and 3-hour interval forecasts are included.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'location',
                label: 'Optional: Ort',
                type: 'text',
                required: false
            },
        ]
    },

    [AgentSkillType.ROUTING]: {
        type: AgentSkillType.ROUTING,
        name: 'OSM Routen',
        description: 'Der Agent kann Routen berechnen (zu Fuß, Fahrrad, Auto).',
        icon: GiPathDistance,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'osm-routing'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Provides step-by-step directions between two named places using OpenStreetMap. ' +
                    'Supports different travel modes: walking (default), driving, or cycling.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.POINT_OF_INTERESTS]: {
        type: AgentSkillType.POINT_OF_INTERESTS,
        name: 'OSM Points of Interests',
        description: 'Der Agent kennt interessante Orte (POIs)',
        icon: TfiPin,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'osm-poi'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Searches for points of interest near a location using OpenStreetMap and Overpass. ' +
                    'You can filter by type like \'restaurant\', \'cinema\', or \'swabian\'.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'location',
                label: 'Ort',
                type: 'text',
                required: false
            },
            {
                key: 'radius',
                label: 'Radius (km)',
                type: 'number',
                required: false
            },
        ]
    },

    [AgentSkillType.CALCULATOR]: {
        type: AgentSkillType.CALCULATOR,
        name: 'Taschenrechner',
        description: 'Der Agent kann mathematische Formeln berechnen.',
        icon: PiMathOperationsBold,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'safe_calculator'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Evaluates mathematical expressions with support for functions like sin, cos, sqrt, etc.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.TRANSLATOR]: {
        type: AgentSkillType.TRANSLATOR,
        name: 'Übersetzer',
        description: 'Der Agent kann Text von einer Sprache in eine andere übersetzen.',
        icon: MdTranslate,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'translator'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Translates text using an LLM. Input includes the text, target language, ' +
                    'and optional source language.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.IMAGE_UNDERSTANDING]: {
        type: AgentSkillType.IMAGE_UNDERSTANDING,
        name: 'Bilder verstehen',
        description: 'Der Agent kann Bilder interpertieren.',
        icon: MdImageSearch,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'image_understanding'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Uses an LLM to describe an image from a URL or a base64 data URL. ' +
                    'Returns a detailed natural language description as a Document.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.IMAGE_CREATION]: {
        type: AgentSkillType.IMAGE_CREATION,
        name: 'Bilder erstellen',
        description: 'Der Agent kann Bilder erstellen.',
        icon: LuImagePlus,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'image_creation'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Generates an image with Azure GPT-Image-1. Returns an HTML img ' +
                    'tag with a temporary URL. ',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.TEXT_TO_SPEECH]: {
        type: AgentSkillType.TEXT_TO_SPEECH,
        name: 'Text zu Audio',
        description: 'Der Agent kann Audio-Dateien erstellen.',
        icon: PiSpeakerHighBold,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'text_to_speech'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Generates speech from text using Azure OpenAI TTS, infers voice from input language if not specified. ' +
                    'Returns a link to the audio-file generated for downstream usage and/or download.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.INTERVIEWS]: {
        type: AgentSkillType.INTERVIEWS,
        name: 'Interviews (CIS)',
        description: 'Der Agent kann den Anwender interviewen und die Ergebnisse zum lernen nutzen.',
        icon: TbUserQuestion,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'cis_interview'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 'tdb',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'instructions',
                label: 'Interview Instructions',
                type: 'textarea',
                required: true
            }
        ]
    },

    [AgentSkillType.DE_VH_KURSE]: {
        type: AgentSkillType.DE_VH_KURSE,
        name: 'VH-Kurse',
        description: 'Der Agent kennt die Kurse der Volkshochschule.',
        icon: RiPresentationLine,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'vhs_course_search'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Searches the German Volkshochschule (VHS) for courses. Accepts a query, city, radius, and ' +
                    'course type filter.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'max_results',
                label: 'Anzal Treffer (max)',
                type: 'number',
                required: true
            },
            {
                key: 'city',
                label: 'Optional: Stadt',
                type: 'text',
                required: false
            },
        ]
    },

    [AgentSkillType.DE_SERVICE_BW]: {
        type: AgentSkillType.DE_SERVICE_BW,
        name: 'Service BW',
        description: 'Der Agent kennt die Diestleistungen aus Service BW.',
        icon: AiOutlineApi,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'service_bw'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Fetch information from the service-bw API in Baden-Württemberg (Germany) about public services.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'municipality',
                label: 'Municipality',
                type: 'text',
                required: true
            },
            {
                key: 'serviceTypes',
                label: 'Service Types',
                type: 'select',
                required: true,
                options: ['All', 'Citizens', 'Business', 'Administration']
            }
        ]
    },

    [AgentSkillType.DE_DIGITALE_BIB]: {
        type: AgentSkillType.DE_DIGITALE_BIB,
        name: 'Dt. Digitale Bibliothek',
        description: 'Der Agent kann die Inhalte der deutschen digitalen Bibliothek durchsuchen.',
        icon: IoLibraryOutline,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'dt_digitale_bibliothek'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the archives of the Detusche Digitale Bibliothek for a given query.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.DE_TEXTARCHIV]: {
        type: AgentSkillType.DE_TEXTARCHIV,
        name: 'Deutsches Textarchiv',
        description: 'Der Agent kann die Inhalte des deutschen Textarchivs durchsuchen.',
        icon: GoArchive,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'de_textarchiv'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the archives of the Detusche Textarchiv for a given query.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.OPEN_LIBRARY]: {
        type: AgentSkillType.OPEN_LIBRARY,
        name: 'Open Library',
        description: 'Der Agent kann die Inhalte der Open Library durchsuchen.',
        icon: HiOutlineBuildingLibrary,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'openLibrary'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the archives of the Open Library for a given query.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.GOOGLE_BOOKS]: {
        type: AgentSkillType.GOOGLE_BOOKS,
        name: 'Google Books',
        description: 'Der Agent kann Google Books durchsuchen.',
        icon: TbBrandGoogle,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'googleBooks'
            },
            {
                key: 'system:skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the archives of Google Books for a given query.'
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.TMDB]: {
        type: AgentSkillType.TMDB,
        name: 'The Movie DB',
        description: 'Der Agent kann The Movie DB durchsuchen.',
        icon: SiThemoviedatabase,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'Movie_DB'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the archives of the Movie DB for a given query.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.ARXIV]: {
        type: AgentSkillType.ARXIV,
        name: 'arXiv',
        description: 'Der Agent kann Paper und Publikationen aus arXiv durchsuchen.',
        icon: SiArxiv,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'ArXiv',
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Search the publications of arXiv for a given query.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.DEJURE]: {
        type: AgentSkillType.DEJURE,
        name: 'dejure.org',
        description: 'Der Agent kennt über 300 dt. Gesetze und Millionen rechtliche Entscheidungen.',
        icon: GoLaw,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'dejure.org',
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'A tool that provides access to a legal database containing full texts of approximately 300 German laws and over 1.9 million court decisions. Each decision includes references and citations from legal scholarship. Only officially or privately published documents—particularly those available in official court databases—are indexed.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.ENAIO]: {
        type: AgentSkillType.ENAIO,
        name: 'ENAIO',
        description: 'Der Agent kann Dokumente aus dem DMS enaio durchsuchen.',
        icon: TbDatabaseLeak,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'ENAIO'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'tbd',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.SHAREPOINT]: {
        type: AgentSkillType.SHAREPOINT,
        name: 'MS Sharepoint',
        description: 'Der Agent kann Dokumente aus MS Sharepoint durchsuchen.',
        icon: TiVendorMicrosoft,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'MS_Sharepoint'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue:
                    'Use this tool to search across internal knowledge sources, including intranet pages, ' +
                    'PDF and markdown files, user profiles, app listings, and posts. It returns relevant documents ' +
                    'that may contain answers to employee questions, organizational policies, contact information, ' +
                    'service instructions, or operational procedures.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.PIROBASE]: {
        type: AgentSkillType.PIROBASE,
        name: 'Pirobase',
        description: 'Der Agent kann Dokumente aus dem DMS Pirobase durchsuchen.',
        icon: TbDatabaseSearch,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'Pirobase'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Use this tool to search across internal knowledge sources, including intranet pages, ' +
                    'PDF and markdown files, user profiles, app listings, and posts. It returns relevant documents ' +
                    'that may contain answers to employee questions, organizational policies, contact information, ' +
                    'service instructions, or operational procedures.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.STAFFBASE]: {
        type: AgentSkillType.STAFFBASE,
        name: 'Staffbase',
        description: 'Der Agent kann Dokumente aus dem DMS Staffbase durchsuchen.',
        icon: TbDatabaseSearch,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'Staffbase'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Use this tool to search across internal knowledge sources, including intranet pages, ' +
                    'PDF and markdown files, user profiles, app listings, and posts. It returns relevant documents ' +
                    'that may contain answers to employee questions, organizational policies, contact information, ' +
                    'service instructions, or operational procedures.',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
        ]
    },

    [AgentSkillType.OPARL]: {
        type: AgentSkillType.OPARL,
        name: 'oParl API',
        description: 'Der Agent kann Dokumente aus einer oParl API nutzen.',
        icon: RiGovernmentLine,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'OParl_API'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'OParl_API',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'entry_url',
                label: 'Url',
                type: 'text',
                required: true
            },
        ]
    },

    [AgentSkillType.CUSTOM_API]: {
        type: AgentSkillType.CUSTOM_API,
        name: 'Eigene API',
        description: 'Der Agent kann Dokumente aus einer API nutzen.',
        icon: FaCode,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: true
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue:
                    'tbd',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'endpoint',
                label: 'API Endpoint',
                type: 'url',
                required: true
            },
            {
                key: 'method',
                label: 'HTTP Method',
                type: 'select',
                required: true,
                options: ['GET', 'POST']
            },
            {
                key: 'headers',
                label: 'Headers (JSON)',
                type: 'text',
                required: false
            },
            {
                key: 'authentication',
                label: 'Authentication Type',
                type: 'select',
                required: true,
                options: ['None', 'API Key', 'Bearer Token', 'Basic Auth']
            },
            {
                key: 'authValue',
                label: 'Authentication Value',
                type: 'text',
                required: false
            }
        ]
    },

    [AgentSkillType.KOMMONE_EVENT]: {
        type: AgentSkillType.KOMMONE_EVENT,
        name: 'komm.One Event API',
        description: 'Der Agent kann Veranstaltungen der Komm.ONE API abrufen.',
        icon: MdOutlineEventNote,
        configurationFields: [
            {
                key: 'skill_name',
                label: 'Skill Name',
                type: 'text',
                required: false,
                defaultValue: 'Komm.ONE_EVENT'
            },
            {
                key: 'system_skill_description',
                label: 'Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: 
                    'Komm.ONE_EVENT',
                read_only: true,
            },
            {
                key: 'user_skill_description',
                label: 'Optional: Skill Beschreibung',
                type: 'textarea',
                required: false,
                defaultValue: '',
            },
            {
                key: 'apiKey',
                label: 'API Key',
                type: 'text',
                required: true
            },
            {
                key: 'eventTypes',
                label: 'Event Types',
                type: 'select',
                required: true,
                options: ['All', 'Public', 'Internal', 'Administrative']
            },
            {
                key: 'municipality',
                label: 'Municipality',
                type: 'text',
                required: true
            }
        ]
    },

}; 